import * as React from 'react';
import {
  Dialog,
  DialogContent,
  Grid,
  Button,
  Typography,
} from '@material-ui/core';
import type { AxiosError } from 'axios';
import axios from 'axios';
import type { SWRResponse } from 'swr/dist/types';
import { useSnackbar } from 'notistack';
import type { Message } from './NotificationTypes';

interface MessageModalProps {
  onClose: () => void;
  open: boolean;
  notification: Message;
  notificationMutate: SWRResponse<{ notifications:Message[] }, unknown>['mutate']
}
const MessageModal: React.FC<MessageModalProps> = ({
  onClose, notification, open, notificationMutate,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const acknowledgeNotificationFunction = (notificationIdParameter:string) => {
    axios.post('/Notification/UpdateNotification',
      { NotificationId: notificationIdParameter })
      .then(() => {
        enqueueSnackbar(`${notification.title} marked as Done`, { variant: 'success' });
        notificationMutate().catch(() => {});
        onClose();
      })
      .catch((error: AxiosError) => {
        enqueueSnackbar(JSON.stringify(error?.response?.data), { persist: false, variant: 'error' });
      });
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent>
        <Grid container direction="row-reverse" spacing={1}>

          <Grid item xs={12}>
            <Typography variant="h5">
              {notification.title}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '1rem' }} variant="subtitle1">
              { // eslint-disable-next-line react/no-danger
                <div dangerouslySetInnerHTML={{ __html: notification.note.replace(/\r?\n/g, '<br>') }} />
              }
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.75rem' }} variant="subtitle1">
              {notification.created instanceof Date ? notification.created : new Date(`${notification.created}z`).toLocaleString()}
            </Typography>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              onClick={() => acknowledgeNotificationFunction(notification.id)}
            >
              {'Mark Done'}
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              onClick={onClose}
            >
              {'Close'}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default MessageModal;
